import React from "react";
import { Checkbox, ClickAwayListener, FormControlLabel, Paper, Popper, Stack, TextField } from "@mui/material";
import { GreenrouterColumn } from "../../../../data";

type Props = {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
	columns: GreenrouterColumn[];
	visibleCount: number;
	onColumnsChange?: (columns: GreenrouterColumn[]) => void;
};

const ManageColumnsPopper = ({ anchorEl, open, onClose, columns, visibleCount, onColumnsChange }: Props) => {
	const [search, setSearch] = React.useState("");

	const filteredColumns = columns.filter((c) => c.label.toLowerCase().includes(search.toLowerCase()));

	return (
		<Popper
			open={open}
			anchorEl={anchorEl}
			placement="top-end"
			modifiers={[
				{
					name: "preventOverflow",
					options: { boundary: "clippingParents" },
				},
			]}
			sx={{ zIndex: 10, top: '-10px' }}
		>
			<ClickAwayListener onClickAway={onClose}>
				<Paper sx={{ width: 280, p: 1 }}>
					<TextField
						size="small"
						placeholder="Search columns"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						fullWidth
						sx={{ mb: 1 }}
					/>
					<Stack sx={{ maxHeight: 240, overflowY: "auto", paddingX: 1.5 }}>
						{filteredColumns.map((col) => (
							<FormControlLabel
								key={col.field}
								control={
									<Checkbox
										size="small"
										checked={col.visible}
										disabled={col.hideable === false || (col.visible && visibleCount === 1)}
										onChange={() =>
											onColumnsChange?.(
												columns.map((c) =>
													c.field === col.field ? { ...c, visible: !c.visible } : c
												)
											)
										}
									/>
								}
								label={col.label}
							/>
						))}
					</Stack>
				</Paper>
			</ClickAwayListener>
		</Popper>
	);
};

export default ManageColumnsPopper;
